// frontend/src/hooks/useSidebarZIndex.js
import { useContext, useEffect } from 'react';
import SidebarZIndexContext from '../contexts/SidebarZIndexContext';

export const useSidebarZIndex = (sidebarId) => {
  const context = useContext(SidebarZIndexContext);
  
  if (!context) {
    throw new Error('useSidebarZIndex must be used within a SidebarZIndexProvider');
  }
  
  const { registerSidebar, unregisterSidebar, getSidebarZIndex, getHighestZIndex } = context;
  
  // Register sidebar when component mounts
  useEffect(() => {
    if (sidebarId) {
      registerSidebar(sidebarId);
      
      // Cleanup when component unmounts
      return () => {
        unregisterSidebar(sidebarId);
      };
    }
  }, [sidebarId, registerSidebar, unregisterSidebar]);
  
  // Get the current z-index for this sidebar
  const zIndex = getSidebarZIndex(sidebarId);
  
  return {
    zIndex,
    getHighestZIndex,
    registerSidebar,
    unregisterSidebar
  };
};
